import { getStore } from '../store/zeroDepStore';
import { getAppParams } from '../utils/getAppParams';
export const getProjectInfo = async () => {
    const { projectId, env, branch } = getAppParams();
    // 获取应用配置(只会请求一次)
    const project = await getStore().dispatch('runtime/getProject', {
        projectId,
        env,
    });
    return { project, branch, projectId, env };
};
